import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { traceFunction } from "@core/datadog-server";
export const getStaticPropsfn = async ({ preview =false  })=>{
    try {
        const story = await getStoryBySlug(`store`, {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Store information story not found");
        }
        const heroProps = {
            ...story.content.hero[0]
        };
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    showBorderRadius: true,
                    heroProps
                }
            },
            revalidate: 60
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            console.log(error);
        }
        return {
            notFound: true
        };
    }
};
export const getStaticProps = traceFunction("store-page.getStaticProps", getStaticPropsfn);
